var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#500D76",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p6p9q1w2va)",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.933 10a1.1 1.1 0 0 0 .22 1.214l.04.04a1.333 1.333 0 1 1-1.886 1.886l-.04-.04a1.1 1.1 0 0 0-1.214-.22 1.1 1.1 0 0 0-.667 1.007V14a1.333 1.333 0 1 1-2.666 0v-.06A1.1 1.1 0 0 0 6 12.934a1.099 1.099 0 0 0-1.213.22l-.04.04a1.334 1.334 0 1 1-1.887-1.887l.04-.04a1.1 1.1 0 0 0 .22-1.213 1.1 1.1 0 0 0-1.007-.667H2A1.333 1.333 0 1 1 2 6.72h.06A1.1 1.1 0 0 0 3.066 6a1.1 1.1 0 0 0-.22-1.213l-.04-.04A1.333 1.333 0 1 1 4.694 2.86l.04.04a1.1 1.1 0 0 0 1.214.22H6a1.1 1.1 0 0 0 .667-1.006V2a1.333 1.333 0 0 1 2.666 0v.06A1.1 1.1 0 0 0 10 3.067a1.1 1.1 0 0 0 1.213-.22l.04-.04a1.333 1.333 0 1 1 1.887 1.887l-.04.04a1.1 1.1 0 0 0-.22 1.213V6a1.1 1.1 0 0 0 1.006.667H14a1.333 1.333 0 1 1 0 2.667h-.06a1.1 1.1 0 0 0-1.007.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p6p9q1w2va"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBlueIcon);
export default __webpack_public_path__ + "static/media/SettingBlueIcon.6d9d4104958c3dbd6400c040def97657.svg";
export { ForwardRef as ReactComponent };